module.exports = __webpack_public_path__ + "img/btn-play-store.517f1da1.png";